// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../../styles/variables.css\"","secondary":"#33C370","container":"RCGluCC-iqWWAKEVw7RWt","field-wrapper":"_2CdpdARXCcP8QO2qgCt-tD","remove-item-icon":"_1WRJ3SXDHqd49gM55yTcQQ","input":"_368ZNhu71LOHuVv0t4zYQv","input-wrapper":"_2vpmrabTEK7HtUt5UDa-7E","button":"KhVbhwcwMk-0Xjw9KI165","add-item-icon":"_3gaIeUXF_AYP7bZYoQsTqF"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Module/components/DynamicInputList.mod.css
// module id = 1713
// module chunks = 0